import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import {translate} from "react-i18next";

class FloatingLabelInput extends Component {
  constructor(props){
    super(props)
    props.value || props.defaultValue
    this.state = {
      floating: (props.value || props.defaultValue) ? true : false
    }

  }

  onFocus = (e) => {
    this.setState({floating: true})
  }

  onBlur = (e) => {
    if (e.target.value.length > 0){
      this.setState({floating: true})
    }
    if (e.target.value.length == 0){
      this.setState({floating: false})
    }
  }

  onChange = (e, callback) => {
    this.setState({floating: true})
    if (callback){
      callback(e)
    }
  }

  onClick = () => {
    this._input.focus()
  }

  render() {
    const { type, className, value, defaultValue, onChange, label, error } = this.props
    const { floating } = this.state
    const floatingClass = floating ? 'floating' : ''
    return (
      <div className={`floating-label-input ${error && error.length >  0 && 'has-error'}`}>
        <label onClick={this.onClick} className={floatingClass} >{label}</label>
        <input
          ref={(e) => this._input = e}
          className={className}
          defaultValue={defaultValue}
          type={type}
          value={value}
          onChange={e => this.onChange(e, onChange)}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        { error && error.length > 0 ? <span className="error">{error}</span> : null }
      </div>
    );
  }
}

export default FloatingLabelInput;



// WEBPACK FOOTER //
// ./src/components/common/FloatingLabelInput/FloatingLabelInput.js